// Project scope picker for team views (architecture sprint-11 §9.2, §9.3). Active projects first, then
// archived ones with "(archived)"; "All projects" only where the caller may see every project (Admins).
import { Label } from '@/components/ui/label';
import { NativeSelect } from '@/components/ui/native-select';
import type { OversightProject } from '@/types/settings';

export const ALL_PROJECTS_SCOPE = 'all';

interface ProjectScopeSelectProps {
  id: string;
  value: string;
  projects: readonly OversightProject[];
  allowAll: boolean;
  onChange: (value: string) => void;
}

export function ProjectScopeSelect({ id, value, projects, allowAll, onChange }: ProjectScopeSelectProps): JSX.Element {
  return (
    <div className="w-full max-w-xs space-y-1">
      <Label htmlFor={id}>Project</Label>
      <NativeSelect id={id} value={value} onChange={(e) => onChange(e.target.value)}>
        {allowAll && <option value={ALL_PROJECTS_SCOPE}>All projects</option>}
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.status === 'archived' ? `${p.name} (archived)` : p.name}
          </option>
        ))}
      </NativeSelect>
    </div>
  );
}

/** A valid scope from the URL, else the default (All for Admins, else the first project). */
export function resolveScope(raw: string | null, projects: readonly OversightProject[], allowAll: boolean): { scope: string | null; valid: boolean } {
  const valid = raw !== null && ((allowAll && raw === ALL_PROJECTS_SCOPE) || projects.some((p) => p.id === raw));
  if (valid) return { scope: raw, valid };
  return { scope: allowAll ? ALL_PROJECTS_SCOPE : (projects[0]?.id ?? null), valid: false };
}
